<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/StfrW8/tc-custom/9781605098647.jpg?1700880600234" alt="This image is the cover for the book Power of Your Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Power of Your Past
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover your path of personal and professional development with this practical guide to actively and purposefully engaging with your own past.</b><br/>  <br/> Most of us don't use our yesterdays very well. With so much focus on living in the moment, we neglect to engage in creative reflection on our personal histories. In <i>The Power Of Your Past</i>, John Schuster demonstrates that the past is the most valuable, most accessible, and yet most under-utilized resource for anyone wanting to make positive changes.<br/>  <br/> Offering a practical three-phase model for working with one’s past—Recalling, Reclaiming, and Recasting—Schuster illustrates the process with inspiring histories of those who have experienced transformative results. Schuster provides insight, encouragement, and practical steps for essential professional and personal development. Readers who follow this model will make progress in their endeavors, overcome persistent obstacles, and make decisions based on their own truth rather than relying on someone else’s.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John P. Schuster
      </h2>
      
      <p class="authorDescription body article">John P. Schuster is an author, executive coach, CEO mentor, consultant and facilitator who works with established corporations, government, nonprofits and entrepreneurs. His business The Schuster Kane Alliance, Inc. specializes in coaching, leadership training, and financial acumen through its business simulation Profit and Cash®, which has been played by 450,000 participants across a range of industries. John serves as a faculty member for coaching certification programs at Columbia University and the Hudson Institute of Santa Barbara and is also adjunct faculty for the MBA Leadership program at Rockhurst University in Kansas City, MI. He is a mentor with Merryck and Co., the largest CEO mentoring firm in the world. He has been voted trainer of the year by the Kansas City chapter of the American Society of Training and Development and was a chairman for Vistage, a peer-learning group for CEOs, in both Kansas City and Cincinnati.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15c3311d